import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hotels from "../data/packages";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Booking() {
  const { id } = useParams();
  const query = useQuery();
  const navigate = useNavigate();
  const pkg = Hotels.find((p) => p.id === Number(id));
  const boardIndex = Number(query.get("board")) || 0;

  if (!pkg) {
    return (
      <>
        <Navbar />
        <div style={{ padding: 50, minHeight: "60vh", textAlign: "center" }}>
          <h2>Sorry, this package could not be found!</h2>
          <button
            style={{
              padding: "12px 32px",
              background: "#4282ff",
              color: "white",
              border: "none",
              fontSize: 18,
              borderRadius: 8,
              marginTop: 30,
              cursor: "pointer"
            }}
            onClick={() => navigate("/packages")}
          >
            Back to all Deals
          </button>
        </div>
        <Footer />
      </>
    );
  }

  const selectedBoard = pkg.boards[boardIndex];

  return (
    <>
      <Navbar />
      <div style={{
        background: "#f6f6f6",
        minHeight: "90vh",
        padding: "40px 10px",
        maxWidth: 750,
        margin: "auto",
        borderRadius: 18,
        marginTop: 32
      }}>
        <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 16 }}>
          Book Your Holiday
        </h1>
        <div style={{
          background: "#fff",
          border: "1.5px solid #aaa",
          borderRadius: 14,
          padding: 28,
          marginBottom: 27
        }}>
          <h2 style={{ fontSize: 23, marginBottom: 14 }}>{pkg.name}</h2>
          <div>
            <strong>Destination:</strong> {pkg.destination}, {pkg.country}
          </div>
          <div>
            <strong>Hotel Board:</strong> {selectedBoard.type}
          </div>
          
          <div>
            <strong>Duration:</strong> {pkg.nights} nights (Return flights included)
          </div>
          <div>
            <strong>Price:</strong> £{selectedBoard.price}pp
          </div>
          <div>
            <strong>Holiday Protected:</strong> {pkg.Protected ? "Yes" : "Yes"}
          </div>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            alert("Your request has been submitted! Our agent will contact you.");
            navigate("/packages");
          }}
          style={{ display: "flex", flexDirection: "column", gap: 18 }}
        >
          <label>
            Full Name
            <input
              required
              type="text"
              placeholder="Enter your full name"
              style={{ width: "100%", padding: "10px", borderRadius: 7, border: "1px solid #ccc", marginTop: 3 }}
            />
          </label>
          <label>
            Contact Number
            <input
              required
              type="tel"
              placeholder="Your phone number"
              style={{ width: "100%", padding: "10px", borderRadius: 7, border: "1px solid #ccc", marginTop: 3 }}
            />
          </label>
          <label>
            Email Address
            <input
              required
              type="email"
              placeholder="Email address"
              style={{ width: "100%", padding: "10px", borderRadius: 7, border: "1px solid #ccc", marginTop: 3 }}
            />
          </label>
          <label>
            Number of Adults
            <input
              type="number"
              min={1}
              defaultValue={2}
              style={{ width: 80, padding: "10px", borderRadius: 7, border: "1px solid #ccc", marginTop: 3 }}
            />
          </label>
          <label>
            Number of Children
            <input
              type="number"
              min={0}
              defaultValue={0}
              style={{ width: 80, padding: "10px", borderRadius: 7, border: "1px solid #ccc", marginTop: 3 }}
            />
          </label>
          <label>
            Special Requests
            <textarea
              placeholder="Anything else? (Optional)"
              rows={3}
              style={{ width: "100%", padding: "10px", borderRadius: 7, border: "1px solid #ccc", marginTop: 3 }}
            />
          </label>
          <button
            type="submit"
            style={{
              background: "#ff6b00",
              color: "white",
              fontWeight: 700,
              padding: "13px 38px",
              border: "none",
              borderRadius: 8,
              fontSize: 19,
              marginTop: 15,
              cursor: "pointer"
            }}
          >
            ✅ Submit Booking Request
          </button>
        </form>
      </div>
      <Footer />
    </>
  );
}